import api from '@/apis/bu/buPlanWithDrawAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('buPlanWithDraw', api);

const state = {
  ...crud.state,
  _config: {
    table: 'bu_plan_with_draw',
    field: {
      key: 'ref_id',
      code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Xóa rút dự toán
   * NXCHIEN 15.04.2022
   */
  async deleteMultiBUPlan(context, payload) {
    let res = await api.deleteMultiBUPlan(payload);
    //cập nhật danh sách
    let deleted = [];
    if (res) {
      for (let i = 0; i < payload.Models.length; i++) {
        //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
        if (res.hasOwnProperty(String(i))) {
          continue;
        }

        deleted.push(payload.Models[i]);
      }
    }
    context.commit('deleteItems', deleted);
    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
